import TableWrapper from "../../../../../Components/Common/Tables/Tanstack/components/TableWrapper";
import CommonHeader from "../../../../../Components/Common/CommonHeader/CommonHeader";
import { useDispatch, useSelector } from "react-redux";
import useSelectedProductMappingColumns from "../Hooks/useSelectedProductMappingColumns";
import { useEffect } from "react";
import { getOrganizationId } from "../../../../../Utils/CommonUtils";
// import { getUserProductList } from "../UserService";
import {
  setProductMappingData,
  setProductSorting,
  setUserSorting,
} from "../../../../../slices/team/users/usersSlice";
import SelectDropdownProductMapping from "./SelectDropdownProductMapping";
import { getFilteredDataWithTabs } from "../../../../../Utils/CommonService";
import ProductFilter from "./ProductFilter";

const ProductMapping = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.users.selectedUser.detailsData);
  const productMappingData = useSelector(
    (state) => state.users.selectedUser.productMappingData
  );
  const { productMappingColumns, selectedRows, selectAll } =
    useSelectedProductMappingColumns(productMappingData);
  const apiTabData = useSelector((state) => state.common.pagination.tabs);

  const triggerRender = useSelector((state) => state.common.triggerRender);
  const filterTrigger = useSelector((state) => state.common.trigger.filterButton);
  const filterForm = useSelector((state) => state.users.productMappingFilter.form);
  const filterApi = useSelector(
    (state) => state.users.productMappingFilter.filterApi
  );
  const totalRows = useSelector((state) => state.common.pagination.totalCount);
  const enterpriseid = localStorage.getItem("enterpriseid");

  const sortColumn = useSelector((state) => state.users.productSorting.column);
  const sortOrder = useSelector((state) => state.users.productSorting.order);
  const ownerId = getOrganizationId();
  const userid = localStorage.getItem("userId");

  return (
    <div>
      <CommonHeader
        filterComponent={<ProductFilter />}
        selectComponent={
          <SelectDropdownProductMapping selectedRows={selectedRows} />
        }
        dash={true}
      />
      <div className="drill-table-mapping">
        <TableWrapper
          columns={productMappingColumns}
          data={productMappingData}
          apiTabData={apiTabData}
          paginatedApi
          filterApi={filterApi}
          filterApiEntity={"PSP"}
          filterApiListEntity={"UPM"}
          filterApiFunction={setProductMappingData}
          filterApiService={!selectAll ? getFilteredDataWithTabs : () => { }}
          filterForm={filterForm}
          totalRows={totalRows}
          status={"ALL"}
          statusColumn={"status"}
          serverSort
          serverSortColumn={sortColumn}
          serverSortOrder={sortOrder}
          userId={data?.entityid}
          serverSortState={setProductSorting}
          hideTabsWrapper={true}
        />
      </div>
    </div>
  );
};

export default ProductMapping;
